import React, { createContext, useContext } from 'react';

import { CommunityIncentiveFiltersType, CommunityIncentiveType } from '../../../types/incentives';

type CommunityIncentivesContent = {
  communityId: number;
  data: CommunityIncentiveType[];
  isLoading: boolean;
  isFetching: boolean;
  modalType: string | undefined;
  selectedIncentive: CommunityIncentiveType | undefined;
  setModalType: (type: string | undefined) => void;
  refetch: () => void;
  filters: Partial<CommunityIncentiveFiltersType>;
  setFilters: (filters: any) => void;
  setSelectedIncentive: (incentive: CommunityIncentiveType | undefined) => void;
};

export const CommunityIncentivesContext = createContext<CommunityIncentivesContent>({
  communityId: -1,
  data: [],
  isLoading: false,
  isFetching: false,
  filters: {
    careTypes: [],
  },
  selectedIncentive: undefined,
  modalType: undefined,
  refetch: () => {
    // Do nothing
  },
  setModalType: () => {
    // Do nothing
  },
  setSelectedIncentive: () => {
    // Do Nothing
  },
  setFilters: () => {
    // Do nothing
  },
});

export const useCommunityIncentivesContext = () => useContext(CommunityIncentivesContext);
